import React, { useEffect } from 'react';
import { arrayOf, shape, bool, number, func } from 'prop-types';
import { schema as addressSchema } from 'components/Address/util';
import AddAdddressButton from 'components/Address/AddressBook/AddAdddressButton';
import {
  MappedAddressRows,
  AddressBookList,
  AddressFormModalRouted,
} from 'components/Address/common';
import { scrollToClass } from 'components/Forms/utilities/ErrorScrolling/util';
import Alert from '@johnlewispartnership/wtr-ingredients/ingredients/Alert';
import styles from './AddressBook.scss';

const addressBookDefaultPropAddAddress = () => {};

const AddressBook = props => {
  const {
    addressCount,
    addAddress = addressBookDefaultPropAddAddress,
    addresses,
    collapsed = true,
    collapsedAddresses,
    hasError = false,
    hideExpandCollapse,
    canSelectContactAddress = false,
    manualOnly = true,
    onExpand,
    showAddressBookList,
  } = props;

  useEffect(() => {
    if (hasError) {
      scrollToClass('addressApiError');
    }
  }, [hasError]);

  return (
    <div data-test="address-book">
      {hasError && (
        <div className="addressApiError">
          <Alert
            type="error"
            title="Something went wrong."
            message="Apologies something went wrong when editing your address. Please try again or at a later time."
            data-test="address-book-error"
          />
        </div>
      )}
      {showAddressBookList ? (
        <>
          <AddressBookList
            {...{
              addresses,
              addressCount,
              collapsed,
              collapsedChildren: (
                <MappedAddressRows
                  addresses={collapsedAddresses}
                  isEditable
                  deletable={addressCount > 1}
                  canSelectContactAddress={canSelectContactAddress}
                />
              ),
              hideExpandCollapse,
              manualOnly,
              canSelectContactAddress,
              onExpand,
            }}
          >
            <div className={styles.addAddressSmallButtonContainer}>
              <AddAdddressButton
                {...{ showAsLink: false, showAsPlaceholder: false, small: true }}
              />
            </div>
          </AddressBookList>
          <AddressFormModalRouted manualOnly={manualOnly} />
        </>
      ) : (
        <>
          <div className={styles.addAddressButtonContainer}>
            <AddAdddressButton
              {...{
                buttonMessage: 'Add a contact address',
                showAsLink: false,
              }}
            />
          </div>
          <AddressFormModalRouted
            manualOnly={manualOnly}
            addAddressTitle="Add a Contact Address"
            onSubmit={address => addAddress(address, { setContactAddress: true })}
          />
        </>
      )}
    </div>
  );
};

AddressBook.propTypes = {
  addressCount: number.isRequired,
  addAddress: func,
  addresses: arrayOf(shape(addressSchema)).isRequired,
  collapsed: bool,
  collapsedAddresses: arrayOf(shape(addressSchema)).isRequired,
  hasError: bool,
  hideExpandCollapse: bool.isRequired,
  manualOnly: bool,
  canSelectContactAddress: bool,
  onExpand: func.isRequired,
  showAddressBookList: bool.isRequired,
};

export default AddressBook;
